import { useMutation, useQueryClient } from "@tanstack/react-query";

import { resetOrgTemplate } from "./api";
import type { BranchTemplateSettingsResponse } from "./api";

// DELETE org-дефолта (откат к заводскому). На успех инвалидируем
// org-запрос — секция показывает «унаследован заводской дефолт».
export function useResetOrgTemplate(): ReturnType<
  typeof useMutation<BranchTemplateSettingsResponse, Error, void>
> {
  const queryClient = useQueryClient();
  return useMutation<BranchTemplateSettingsResponse, Error, void>({
    mutationFn: () => resetOrgTemplate(),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ["branchNameTemplate", "org"],
      });
    },
  });
}
